<template>
    <div :class="[$style.wrapper, { [$style.bottom]: showPayment }]">
        <Typography
            is="div"
            type="caption"
            size="all-caps"
            :class="$style.balance"
            :responsive="false"
        >
            {{ $tr('paymentModal.balanceLabel') }}
        </Typography>
        <Typography
            is="div"
            type="label"
            size="m"
            accent
            :responsive="false"
        >
            <Icon
                name="gold_fennec_coin_small"
                :class="$style.coin"
            />
            {{ `${balance} Gam` }}
        </Typography>
    </div>
</template>
<script setup lang="ts">
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'

defineProps<{
    balance: number
    showPayment: boolean
}>()
</script>

<style module>
.wrapper {
    margin-top: 10px;
    margin-bottom: 20px;
}

.balance {
    color: var(--white-60);
    margin-bottom: 5px;
}

.coin {
    margin-bottom: -5px;
    width: 20px;
    height: 20px;
}

@media (--desktop-small-plus) {
    .bottom {
        position: absolute;
        bottom: 0;
        left: 16px;
    }
}
</style>
